import { render, staticRenderFns } from "./FullDialog.vue?vue&type=template&id=cba223bc&scoped=true"
import script from "./FullDialog.vue?vue&type=script&lang=js"
export * from "./FullDialog.vue?vue&type=script&lang=js"
import style0 from "./FullDialog.vue?vue&type=style&index=0&id=cba223bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba223bc",
  null
  
)

export default component.exports